import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import AuthPage from './pages/AuthPage';
import Home from './pages/Home';
import Discover from './pages/Discover';
import History from './pages/History';
import Profile from './pages/Profile';
import ProfileAccount from './pages/ProfileAccount';
import HelpCenter from './pages/HelpCenter';
import Feedback from './pages/Feedback';
import BookDetail from './pages/BookDetail';
import ChapterReader from './pages/ChapterReader';
import ChapterLearn from './pages/ChapterLearn';
import WordStudy from './pages/WordStudy';
import SentenceStudy from './pages/SentenceStudy';
import NoteStudy from './pages/NoteStudy';
import AdminApp from './admin/AdminApp';
import ReadingHistoryPage from './pages/ReadingHistoryPage';
import BookWordList from './pages/BookWordList';
import BookPhraseList from './pages/BookPhraseList';
import About from './pages/About';
import CategoryBooks from './pages/CategoryBooks';
import NovelVoting from './pages/NovelVoting';
// import TestApi from './TestApi';
import styles from './App.module.css';

// 主应用组件
const AppContent = () => {
  useEffect(() => {
    const handleContextMenu = (e) => e.preventDefault();
    document.addEventListener('contextmenu', handleContextMenu);
    return () => document.removeEventListener('contextmenu', handleContextMenu);
  }, []);
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className={styles.appLoading}>
        <div className={styles.loadingContainer}>
          <div className={styles.loadingSpinner}>加载中...</div>
        </div>
      </div>
    );
  }

  // 如果未认证，显示登录/注册页面
  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/register" element={<AuthPage initialView="register" />} />
        <Route path="/login" element={<AuthPage initialView="login" />} />
        <Route path="*" element={<AuthPage initialView="login" />} />
      </Routes>
    );
  }

  // 如果已认证，显示主应用
  return (
    <Routes>
      {/* 管理员路由 */}
      <Route path="/admin/*" element={
        <ProtectedRoute requireAdmin={true}>
          <AdminApp />
        </ProtectedRoute>
      } />
      
      {/* 测试API路由 */}
      {/* <Route path="/test-api" element={<TestApi />} /> */}
      
      {/* 普通用户路由 */}
      <Route path="/*" element={
        <Layout>
          <Routes>
            <Route path="/" element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            } />
            <Route path="/discover" element={
              <ProtectedRoute>
                <Discover />
              </ProtectedRoute>
            } />
            <Route path="/categories/:categoryId" element={
              <ProtectedRoute>
                <CategoryBooks />
              </ProtectedRoute>
            } />
            <Route path="/history" element={
              <ProtectedRoute>
                <History />
              </ProtectedRoute>
            } />
            <Route path="/history/words" element={
              <ProtectedRoute>
                <History initialView="words" />
              </ProtectedRoute>
            } />
            <Route path="/history/words/:bookKey" element={
              <ProtectedRoute>
                <BookWordList />
              </ProtectedRoute>
            } />
            <Route path="/history/phrases" element={
              <ProtectedRoute>
                <History initialView="phrases" />
              </ProtectedRoute>
            } />
            <Route path="/history/phrases/:bookKey" element={
              <ProtectedRoute>
                <BookPhraseList />
              </ProtectedRoute>
            } />
            <Route path="/history/sentences" element={
              <ProtectedRoute>
                <History initialView="sentences" />
              </ProtectedRoute>
            } />
            <Route path="/history/notes" element={
              <ProtectedRoute>
                <History initialView="notes" />
              </ProtectedRoute>
            } />
            <Route path="/history/novels" element={
              <ProtectedRoute>
                <History initialView="books" />
              </ProtectedRoute>
            } />
            <Route path="/history/study/:bookId" element={
              <ProtectedRoute>
                <WordStudy />
              </ProtectedRoute>
            } />
            <Route path="/profile" element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            } />
            <Route path="/novel-voting" element={
              <ProtectedRoute>
                <NovelVoting />
              </ProtectedRoute>
            } />
            <Route path="/help" element={
              <ProtectedRoute>
                <HelpCenter />
              </ProtectedRoute>
            } />
            <Route path="/profile/history" element={
              <ProtectedRoute>
                <ReadingHistoryPage />
              </ProtectedRoute>
            } />
            <Route path="/profile/account" element={
              <ProtectedRoute>
                <ProfileAccount />
              </ProtectedRoute>
            } />
            <Route path="/feedback" element={
              <ProtectedRoute>
                <Feedback />
              </ProtectedRoute>
            } />
            <Route path="/about" element={
              <ProtectedRoute>
                <About />
              </ProtectedRoute>
            } />
            <Route path="/book/:bookId" element={
              <ProtectedRoute>
                <BookDetail />
              </ProtectedRoute>
            } />
            <Route path="/read/:bookId/:chapterId" element={
              <ProtectedRoute>
                <ChapterReader />
              </ProtectedRoute>
            } />
            <Route path="/read/:bookId/:chapterId/learn" element={
              <ProtectedRoute>
                <ChapterLearn />
              </ProtectedRoute>
            } />
            <Route path="/learn/:bookId/:chapterId/:tab?" element={
              <ProtectedRoute>
                <ChapterLearn />
              </ProtectedRoute>
            } />
            <Route path="/wordstudy/:bookId/:chapterId" element={
              <ProtectedRoute>
                <WordStudy />
              </ProtectedRoute>
            } />
            <Route path="/learn/:bookId" element={
              <ProtectedRoute>
                <WordStudy />
              </ProtectedRoute>
            } />
            <Route path="/learn/sentences/:bookId/:chapterId?" element={
              <ProtectedRoute>
                <SentenceStudy />
              </ProtectedRoute>
            } />
            <Route path="/learn/notes/:bookId" element={
              <ProtectedRoute>
                <NoteStudy />
              </ProtectedRoute>
            } />
          </Routes>
        </Layout>
      } />
    </Routes>
  );
};

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <div className={styles.App}>
            <AppContent />
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
